const EXPERIENCE_ROOT = "/packages/experiences/identity/arrival";

export const GATEWAY_PRESENTATIONS = Object.freeze({
  default: Object.freeze({ id: "default", label: "Floating panel" }),
  "immersive-center": Object.freeze({ id: "immersive-center", label: "Immersive center" }),
});

export const DEFAULT_GATEWAY_PRESENTATION = "immersive-center";

const normalizePresentation = (value) =>
  GATEWAY_PRESENTATIONS[value] ? value : DEFAULT_GATEWAY_PRESENTATION;

export function getGatewayExperience(scene = "login", presentation = DEFAULT_GATEWAY_PRESENTATION) {
  const style = normalizePresentation(presentation);
  const root = `${EXPERIENCE_ROOT}/${scene}`;
  return {
    id: scene,
    presentation: style,
    desktopCandidates: [`${root}/${style}/desktop.webp`, `${root}/default/desktop.webp`],
    mobileCandidates: [`${root}/${style}/mobile.webp`, `${root}/default/mobile.webp`],
    position: "center center",
  };
}

export function readGatewayPresentation() {
  if (typeof window === "undefined") return DEFAULT_GATEWAY_PRESENTATION;
  const requested = new URLSearchParams(window.location.search).get("gatewayStyle");
  return normalizePresentation(requested || window.localStorage.getItem("clikkle.identity.gatewayStyle"));
}
